/* global PRODUCTION, Sentry */

import { usersOnboardProfileState } from 'controllers/users/onboard';
// Admin V2 TOP
import {
  adminEmployeesEmployeeActivitiesState,
  adminEmployeesEmployeeAttachmentsState,
  adminEmployeesEmployeeCarryOverHours,
  adminEmployeesEmployeeCertificatesEditState,
  adminEmployeesEmployeeCertificatesHoursState,
  adminEmployeesEmployeeCertificatesState,
  adminEmployeesEmployeeCertificationsState,
  adminEmployeesEmployeeComplianceState,
  adminEmployeesEmployeeCoursesState,
  adminEmployeesEmployeeEventsState,
  adminEmployeesEmployeeLicensesLicenseAttachmentsState,
  adminEmployeesEmployeeLicensesLicenseEditState,
  adminEmployeesEmployeeLicensesLicenseExtensionsState,
  adminEmployeesEmployeeLicensesLicenseNavState,
  adminEmployeesEmployeeLicenseState,
  adminEmployeesEmployeeNavState,
  adminEmployeesEmployeeProfileState,
  adminEmployeesEmployeeSettingsState,
  adminEmployeesEmployeeTracksState
} from './controllers/admin/employee';

import adminLearningCreateTemplate from './controllers/admin/learningTracks/create/template.html';
import adminEventsExternalTemplate from './controllers/admin/events/external/template.html';

import {
  adminSettingsCompanyState,
  adminSettingsDepartmentsState,
  adminSettingsEmailTemplatesIdState,
  adminSettingsEmailTemplatesState,
  adminSettingsFormsState,
  adminSettingsIntegrationsIdState,
  adminSettingsIntegrationsState,
  adminSettingsLevelsState,
  adminSettingsLocationsState,
  adminSettingsNavState,
  adminSettingsPracticeAreasState,
  adminSettingsTagsState,
  adminSettingsTagsIdState,
  adminSettingsTeamsIdState,
  adminSettingsTeamsState,
  adminSettingsUsersState
} from './controllers/admin/settings';

import { adminAttachmentsState } from './controllers/admin/attachments';

import adminDashboardTemplate from './controllers/admin/dashboard/template.html';
// TODO
import adminCoursesCourseTemplate from './controllers/admin.courses.course.review/template.html';
import authorCoursesCourseTemplate from './controllers/author/course/template.html';

import adminEmployeesComplianceState from './controllers/admin/compliance';
import { adminEmployeesProfileState } from './controllers/admin/employees';

import authorReviewFormsReviewFormTemplate from './controllers/author/evaluationForms/view/template.html';
//STATES
import appState from './controllers/application';

import { appAdminSponsors, appAdminSponsorsSponsor } from 'controllers/admin/sponsors';

import {
  usersMyCoursesState,
  usersCoursesCourseProgressState,
  usersCoursesCourseState,
  usersCoursesState
} from 'controllers/users/courses';

import { usersEventsEventState, usersEventsState } from 'controllers/users/events';

import {
  authState,
  auth0State,
  authMsTeamsState,
  authMsTeamsConsentStartState,
  authMsTeamsConsentEndState,
  usersCpeRequestsState,
  usersCertificationsState,
  usersChangePasswordState,
  userSettings,
  usersForgotPasswordState,
  usersGettingStartedState,
  usersLoginState,
  usersLogoutState,
  usersProfileState,
  usersRegistrationState,
  usersRegisterState,
  usersUpgradeState,
  usersReadOnlyState,
  usersSignUpState
} from 'controllers/users/account';

import {
  usersCertificates,
  usersCertificatesCertificateEditState,
  usersCertificatesCertificatePutState,
  usersCertificatesCertificateUploadState
} from './controllers/users/certificates';

import { adminReportState, userReportState } from './controllers/users/report';

import { usersActivitiesActivityState, usersActivitiesState } from './controllers/users/activities';

import {
  userLicensesLicenseAttachmentsState,
  userLicensesLicenseCarryOverState,
  userLicensesLicenseEditState,
  userLicensesLicenseExtensionsState,
  userLicensesLicenseNavState,
  usersLicensesState
} from './controllers/users/account/licenses';

import {
  usersLearningActivitiesState,
  usersLearningCoursesState,
  usersLearningEventsState,
  usersLearningState,
  usersLearningTracksState
} from './controllers/users/learning';
import usersDashboardState from './controllers/users/dashboard';
import userComplianceState from './controllers/users/compliance/';
import {
  usersSelfStudyFinalState,
  usersSelfStudyQuizState,
  usersSelfStudyState,
  usersSelfStudyVideoState
} from './controllers/users/selfStudy';

import { formsState } from 'controllers/users/forms';
import { formsFormState } from 'controllers/users/forms/form';
import { formsFormReportState } from 'controllers/users/forms/report';
import { usersTeamsState } from 'controllers/users/teams';

import {
  adminLearningTracksState,
  adminLearningTracksTrackEditState,
  adminLearningTracksTrackState
} from './controllers/admin/learningTracks/index';

import { adminCoursesActivationState, adminCoursesApprovalState, adminCoursesState } from 'controllers/admin/courses';

import {
  authorActivitiesActivityState,
  authorActivitiesActivityViewState,
  authorActivitiesState
} from './controllers/author/activities';

import {
  authorEvaluationFormsEvaluationFormEditState,
  authorEvaluationFormsEvaluationFormState,
  authorEvaluationFormsState
} from './controllers/author/evaluationForms';

import authorCoursesStates from './controllers/author/courses';

import {
  bundleState,
  bundlesState,
  courseEvaluationState,
  coursesState,
  courseState,
  eventEvaluationState,
  eventsState,
  eventState,
  internalsState,
  internalsInternalState,
  vendorsState,
  vendorState,
  vendorBundlesState,
  vendorBundleState,
  vendorCoursesState,
  vendorCoursesCourseState,
  vendorEventsState,
  vendorEventsEventState,
  cpeCatalogState,
  cpeCatalogCoursesState,
  cpeCatalogCoursesCourseState,
  cpeCatalogEventsState,
  cpeCatalogEventsEventState
} from './controllers/marketplace';

import eventsEvent from './controllers/admin/events';

import {
  adminEmployeesCertificatesApprovalState,
  adminEmployeesCertificatesReportState,
  adminEmployeesCertificatesState
} from './controllers/admin/certificates';

import {
  adminApprovalsState,
  adminApprovalsCertificatesState,
  adminApprovalsReportState
} from './controllers/admin/approvals';

import {
  eventsEventBase,
  eventsEventAddons,
  eventsEventCertificates,
  eventsEventEmailTemplatesIdState,
  eventsEventEmailTemplatesState,
  eventsEventEvaluations,
  eventsEventInvitations,
  eventsEventMaterials,
  eventsEventOverview,
  eventsEventRegistrations,
  eventsEventReports
} from './controllers/admin/events/event';

import { usersAttachmentsState } from './controllers/users/attachments';

//USER V2 TOP
//USER V2 BOTTOM
// Admin V2 Bottom

export default function(
  $provide,
  $qProvider,
  $stateProvider,
  $urlRouterProvider,
  $locationProvider,
  $httpProvider,
  $sceDelegateProvider,
  angularAuth0Provider,
  $cookiesProvider
) {
  'ngInject';

  $cookiesProvider.defaults.domain = '.prolaera.com';
  $cookiesProvider.defaults.path = '/';
  // $qProvider.errorOnUnhandledRejections(false); // Comment out to catch all errors in $exceptionHandler
  $locationProvider.html5Mode(true).hashPrefix('');

  $provide.decorator('$state', function($delegate, $rootScope) {
    'ngInject';
    $rootScope.$on('$stateChangeStart', function(event, state, params) {
      $delegate.next = state;
      $delegate.toParams = params;
    });
    return $delegate;
  });

  $provide.decorator('$exceptionHandler', function($delegate) {
    'ngInject';
    return function(exception, cause) {
      if (PRODUCTION) {
        Sentry.captureException(exception);
      } else {
        $delegate(exception, cause);
      }
    };
  });

  $httpProvider.useApplyAsync(true);
  $httpProvider.defaults.useXDomain = true;
  // keep the below line false until we change API coors
  $httpProvider.defaults.withCredentials = false;
  delete $httpProvider.defaults.headers.common['X-Requested-With'];
  $httpProvider.defaults.headers.common['Accept'] = 'application/json';
  $httpProvider.defaults.headers.common['Content-Type'] = 'application/json';

  $urlRouterProvider.otherwise('/');
  // $sce.trustAsResourceUrl('https://apiqa.surgent.com');
  $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets domain.  Notice the difference between * and **.
    'https://s3-us-west-2.amazonaws.com/prolaera/content/**',
    'http://s3-us-west-2.amazonaws.com/prolaera/content/**',
    'https://prolaera.s3-us-west-2.amazonaws.com/event-materials/**',
    'https://prolaera.*.amazonaws.com/content/**',
    'https://prolaera.*.amazonaws.com/event-materials/**',
    'http://prolaera.*.amazonaws.com/content/**',
    'https://prolaera.s3.amazonaws.com/attendance-sheets/**',
    'https://apiqa.surgent.com/**',
    'http://apiqa.surgent.com/**',
    'https://www.youtube.com/embed/**',
    'https://apiqa.surgent.com/**',
    'https://maps.googleapis.com/**',
    '*'
  ]);

  $stateProvider
    .state('auth', authState)
    .state('auth0', auth0State)
    .state('authMsTeams', authMsTeamsState)
    .state('authMsTeamsConsentStart', authMsTeamsConsentStartState)
    .state('authMsTeamsConsentEnd', authMsTeamsConsentEndState)
    .state('updateScorm', {
      url: '/updateScorm?urlRedirect&registration_id?course_id?event_id',
      stateName: 'Update Scorm',
      resolve: {
        redirect: /* @ngInject */ ($stateParams, ApiClass, $location, $log) => {
          const { course_id, registration_id, event_id } = $stateParams;
          if (course_id) {
            ApiClass.coursesIdTypeTypeIdPatch(
              { id: course_id, type: 'scormProgress', type_id: registration_id },
              {},
              {}
            )
              .then(() => {
                $location.url(`/courses/${course_id}`);
              })
              .catch(error => {
                $log.error(error);
                throw error;
              });
          }
          if (event_id) {
            ApiClass.eventsIdTypeTypeIdPatch({ id: event_id, type: 'scormAttendee', type_id: registration_id }, {}, {})
              .then(() => {
                $location.url(`/events/${event_id}`);
              })
              .catch(error => {
                $log.error(error);
                throw error;
              });
          }
        }
      }
    })

    .state('login', usersLoginState)
    .state('password', usersForgotPasswordState)
    .state('signup', usersSignUpState)
    .state('registration', usersRegistrationState)
    .state('logout', usersLogoutState)

    .state('app', appState)

    .state('app.register', usersRegisterState)
    .state('app.upgrade', usersUpgradeState)
    .state('app.readOnly', usersReadOnlyState)

    .state('app.activities', usersActivitiesState)
    .state('app.activities.activity', usersActivitiesActivityState)

    .state('app.bundles', bundlesState)
    .state('app.bundles.bundle', bundleState)

    .state('app.courses', coursesState)
    .state('app.courses.course', courseState)
    .state('app.courses.course.evaluation', courseEvaluationState)

    .state('app.events', eventsState)
    .state('app.events.event', eventState)
    .state('app.events.event.evaluation', eventEvaluationState)

    .state('app.cpeCatalog', cpeCatalogState)
    .state('app.cpeCatalog.courses', cpeCatalogCoursesState)
    .state('app.cpeCatalog.courses.course', cpeCatalogCoursesCourseState)
    .state('app.cpeCatalog.events', cpeCatalogEventsState)
    .state('app.cpeCatalog.events.event', cpeCatalogEventsEventState)

    .state('app.internalCourses', internalsState)
    .state('app.internalCourses.event', internalsInternalState)

    .state('app.vendors', vendorsState)
    .state('app.vendors.vendor', vendorState)

    .state('app.vendors.vendor.bundles', vendorBundlesState)
    .state('app.vendors.vendor.bundles.bundle', vendorBundleState)

    .state('app.vendors.vendor.courses', vendorCoursesState)
    .state('app.vendors.vendor.courses.course', vendorCoursesCourseState)

    .state('app.vendors.vendor.events', vendorEventsState)
    .state('app.vendors.vendor.events.event', vendorEventsEventState)

    .state('app.users', {
      url: '/users/:id',
      abstract: true,
      resolve: {
        ResolveClass: 'ResolveClass',
        refresh: /* @ngInject */ ResolveClass => {
          return ResolveClass.refreshLogin();
        }
      }
    })
    .state('app.users.activities', { ...usersActivitiesState, redirectTo: 'app.activities' })
    .state('app.users.activities.activity', {
      ...usersActivitiesActivityState,
      redirectTo: 'app.activities.activity'
    })
    .state('app.users.certificates', usersCertificates)
    .state('app.users.certificates.hours', usersCertificatesCertificatePutState)
    .state('app.users.certificates.edit', usersCertificatesCertificateEditState)
    .state('app.users.certificates.edit.upload', usersCertificatesCertificateUploadState)
    .state('app.users.cpeRequests', usersCpeRequestsState)
    .state('app.users.compliance', userComplianceState)
    .state('app.users.courses', usersCoursesState)
    .state('app.users.courses.course', usersCoursesCourseState)
    .state('app.users.courses.course.progress', usersCoursesCourseProgressState)
    .state('app.users.courses.course.selfStudy', usersSelfStudyState)
    .state('app.users.courses.course.selfStudy.video', usersSelfStudyVideoState)
    .state('app.users.courses.course.selfStudy.quiz', usersSelfStudyQuizState)
    .state('app.users.courses.course.selfStudy.final', usersSelfStudyFinalState)
    .state('app.users.dashboard', usersDashboardState)
    .state('app.users.events', usersEventsState)
    .state('app.users.events.event', usersEventsEventState)
    .state('app.forms', formsState)
    .state('app.forms.form', formsFormState)
    .state('app.forms.form.report', formsFormReportState)
    .state('app.users.gettingStarted', usersGettingStartedState)
    .state('app.users.myCourses', usersMyCoursesState)
    .state('app.users.learning', usersLearningState)
    .state('app.users.learning.tracks', usersLearningTracksState)
    .state('app.users.learning.courses', usersLearningCoursesState)
    .state('app.users.learning.events', usersLearningEventsState)
    .state('app.users.learning.activities', usersLearningActivitiesState)
    .state('app.users.settings', userSettings)
    .state('app.users.settings.attachments', usersAttachmentsState)
    .state('app.users.settings.licenses', usersLicensesState)
    .state('app.users.settings.licenses.license', userLicensesLicenseNavState)
    .state('app.users.settings.licenses.license.attachments', userLicensesLicenseAttachmentsState)
    .state('app.users.settings.licenses.license.carry-over', userLicensesLicenseCarryOverState)
    .state('app.users.settings.licenses.license.edit', userLicensesLicenseEditState)
    .state('app.users.settings.licenses.license.extensions', userLicensesLicenseExtensionsState)
    .state('app.users.settings.profile', usersProfileState)
    .state('app.users.settings.certifications', usersCertificationsState)
    .state('app.users.settings.password', usersChangePasswordState)
    .state('app.users.onboard', usersOnboardProfileState)
    .state('app.users.report', userReportState)
    .state('app.users.teams', usersTeamsState)

    .state('app.admin', {
      url: '/admin',
      abstract: true,
      resolve: {
        ResolveClass: 'ResolveClass',
        refresh: /* @ngInject */ ResolveClass => {
          return ResolveClass.refreshLogin();
        },
        authorAuth: /* @ngInject */ ResolveClass =>
          ResolveClass.refreshLogin().then(() => ResolveClass.authenticateAdmin())
      }
    })
    .state('app.admin.attachments', adminAttachmentsState)
    .state('app.admin.dashboard', {
      url: '/dashboard',
      stateName: 'Admin Dashboard',
      data: {
        specialClass: 'fixed-sidebar'
      },
      views: {
        'a@app': {
          template: adminDashboardTemplate,
          controller: 'AdminDashboardController'
        }
      }
    })
    .state('app.admin.courses', adminCoursesState)
    .state('app.admin.courses.activation', adminCoursesActivationState)
    .state('app.admin.courses.course', {
      url: '/:courseId',
      stateName: 'View Course',
      data: {
        specialClass: 'fixed-sidebar'
      },
      abstract: true,
      resolve: {
        ResolveClass: 'ResolveClass',
        authenticateCompany: /* @ngInject */ ResolveClass =>
          ResolveClass.authenticateCompany('/admin/courses/:courseId')
      },
      views: {
        'a@app': {
          template: authorCoursesCourseTemplate,
          controller: 'AuthorCoursesCourseController'
        }
      }
    })
    .state('app.admin.courses.course.review', {
      url: '/review',
      stateName: 'Update Course Information',
      resolve: {
        ResolveClass: 'ResolveClass',
        authenticateCompany: /* @ngInject */ ResolveClass =>
          ResolveClass.authenticateCompany('/admin/courses/:id/review')
      },
      data: {
        specialClass: 'fixed-sidebar',
        pageTitle: 'Edit Course'
      },
      views: {
        courseReview: {
          template: adminCoursesCourseTemplate,
          controller: 'AdminCoursesCourseReview'
        }
      }
    })
    .state('app.admin.courses.review', adminCoursesApprovalState)
    .state('app.admin.approvals', adminApprovalsState)
    .state('app.admin.approvals.certificates', adminApprovalsCertificatesState)
    .state('app.admin.approvals.cpeRequests', adminApprovalsReportState)
    .state('app.admin.employee', { url: '/employees/:employeeID', abstract: true })
    .state('app.admin.employee.info', { url: '/info', redirectTo: 'app.admin.employees.employee.compliance' })
    .state('app.admin.employees', {
      url: '/employees',
      stateName: 'Employees',
      data: {
        specialClass: 'fixed-sidebar'
      },
      abstract: true
    })
    .state('app.admin.employees.compliance', adminEmployeesComplianceState)
    .state('app.admin.employees.certificates', adminEmployeesCertificatesState)
    .state('app.admin.employees.certificates.approval', adminEmployeesCertificatesApprovalState)
    .state('app.admin.employees.certificates.report', adminEmployeesCertificatesReportState)
    .state('app.admin.employees.employee', adminEmployeesEmployeeNavState)
    .state('app.admin.employees.employee.activities', adminEmployeesEmployeeActivitiesState)
    .state('app.admin.employees.employee.certificates', adminEmployeesEmployeeCertificatesState)
    .state('app.admin.employees.employee.certificates.edit', adminEmployeesEmployeeCertificatesEditState)
    .state('app.admin.employees.employee.certificates.hours', adminEmployeesEmployeeCertificatesHoursState)
    .state('app.admin.employees.employee.compliance', adminEmployeesEmployeeComplianceState)
    .state('app.admin.employees.employee.courses', adminEmployeesEmployeeCoursesState)
    .state('app.admin.employees.employee.events', adminEmployeesEmployeeEventsState)
    .state('app.admin.employees.employee.report', adminReportState)
    .state('app.admin.employees.employee.tracks', adminEmployeesEmployeeTracksState)
    .state('app.admin.employees.employee.settings', adminEmployeesEmployeeSettingsState)
    .state('app.admin.employees.employee.settings.attachments', adminEmployeesEmployeeAttachmentsState)
    .state('app.admin.employees.employee.settings.licenses', adminEmployeesEmployeeLicenseState)
    .state('app.admin.employees.employee.settings.licenses.license', adminEmployeesEmployeeLicensesLicenseNavState)
    .state(
      'app.admin.employees.employee.settings.licenses.license.attachments',
      adminEmployeesEmployeeLicensesLicenseAttachmentsState
    )
    .state('app.admin.employees.employee.settings.licenses.license.carry-over', adminEmployeesEmployeeCarryOverHours)
    .state(
      'app.admin.employees.employee.settings.licenses.license.edit',
      adminEmployeesEmployeeLicensesLicenseEditState
    )
    .state(
      'app.admin.employees.employee.settings.licenses.license.extensions',
      adminEmployeesEmployeeLicensesLicenseExtensionsState
    )
    .state('app.admin.employees.employee.settings.profile', adminEmployeesEmployeeProfileState)
    .state('app.admin.employees.employee.settings.certifications', adminEmployeesEmployeeCertificationsState)
    .state('app.admin.employees.profile', adminEmployeesProfileState)
    .state('app.admin.learning', adminLearningTracksState)
    .state('app.admin.learningCreate', {
      url: '/learningCreate',
      stateName: 'Admin Learning',
      data: {
        specialClass: 'fixed-sidebar'
      },
      views: {
        'a@app': {
          template: adminLearningCreateTemplate,
          controller: 'AdminLearningCreateController',
          controllerAs: 'adminLearningCreateCtrl'
        }
      }
    })
    .state('app.admin.learning.track', adminLearningTracksTrackState)
    .state('app.admin.learning.track.edit', adminLearningTracksTrackEditState)
    .state('app.admin.settings', adminSettingsNavState)
    .state('app.admin.settings.company', adminSettingsCompanyState)
    .state('app.admin.settings.departments', adminSettingsDepartmentsState)
    .state('app.admin.settings.emailTemplates', adminSettingsEmailTemplatesState)
    .state('app.admin.settings.emailTemplates.id', adminSettingsEmailTemplatesIdState)
    .state('app.admin.settings.forms', adminSettingsFormsState)
    .state('app.admin.settings.integrations', adminSettingsIntegrationsState)
    .state('app.admin.settings.integrations.id', adminSettingsIntegrationsIdState)
    .state('app.admin.settings.levels', adminSettingsLevelsState)
    .state('app.admin.settings.locations', adminSettingsLocationsState)
    .state('app.admin.settings.practiceAreas', adminSettingsPracticeAreasState)
    .state('app.admin.settings.tags', adminSettingsTagsState)
    .state('app.admin.settings.tags.id', adminSettingsTagsIdState)
    .state('app.admin.settings.teams', adminSettingsTeamsState)
    .state('app.admin.settings.teams.id', adminSettingsTeamsIdState)
    .state('app.admin.settings.users', adminSettingsUsersState)
    .state('app.admin.sponsors', appAdminSponsors)
    .state('app.admin.sponsors.sponsor', appAdminSponsorsSponsor)

    .state('app.eventManager', eventsEvent)
    .state('app.eventManager.course', {
      url: '/:courseid/events',
      stateName: 'Event Course',
      data: {
        specialClass: 'fixed-sidebar'
      },
      resolve: {
        ResolveClass: 'ResolveClass',
        authenticateCompany: /* @ngInject */ ResolveClass =>
          ResolveClass.authenticateCompany('/admin/event-manager/:courseid/events')
      },
      abstract: true
    })
    .state('app.eventManager.course.event', eventsEventBase)
    .state('app.eventManager.course.event.event-addons', eventsEventAddons)
    .state('app.eventManager.course.event.certificates', eventsEventCertificates)
    .state('app.eventManager.course.event.evaluations', eventsEventEvaluations)
    .state('app.eventManager.course.event.evaluations.evaluation', {
      url: '/courses/:courseId/:eventId/:profile_uid',
      stateName: 'User Review',
      data: {
        specialClass: 'fixed-sidebar',
        pageTitle: 'User Review'
      },
      views: {
        'a@app': {
          template: authorReviewFormsReviewFormTemplate,
          controller: 'AuthorEvaluationFormsEvaluationFormController'
        }
      }
    })
    .state('app.eventManager.course.event.event-info', eventsEventOverview)
    .state('app.eventManager.course.event.materials', eventsEventMaterials)
    .state('app.eventManager.course.event.invitations', eventsEventInvitations)
    .state('app.eventManager.course.event.registrations', eventsEventRegistrations)
    .state('app.eventManager.course.event.reports', eventsEventReports)
    .state('app.eventManager.course.event.emails', eventsEventEmailTemplatesState)
    .state('app.eventManager.course.event.emails.id', eventsEventEmailTemplatesIdState)
    .state('app.eventManager.external', {
      url: '/external/:eventid?tab',
      stateName: 'External Event',
      data: {
        specialClass: 'fixed-sidebar'
      },
      reloadOnSearch: false,
      views: {
        'a@app': {
          template: adminEventsExternalTemplate,
          controller: 'AdminEventsExternalController',
          controllerAs: 'adminEmployeesCertsAddCtrl'
        }
      }
    })

    .state('app.author', {
      url: '/author/:id',
      abstract: true,
      resolve: {
        ResolveClass: 'ResolveClass',
        refresh: /* @ngInject */ ResolveClass => {
          return ResolveClass.refreshLogin();
        },
        authorAuth: /* @ngInject */ ResolveClass =>
          ResolveClass.refreshLogin().then(() => ResolveClass.authenticateAuthor())
      }
    })
    .state('app.author.activities', authorActivitiesState)
    .state('app.author.activities.activity', authorActivitiesActivityState)
    .state('app.author.activities.activity.view', authorActivitiesActivityViewState)
    .state('app.author.courses', authorCoursesStates)
    .state('app.author.courses.course', {
      url: '/:courseId',
      abstract: true,
      resolve: {
        ResolveClass: 'ResolveClass',
        authenticateCompany: /* @ngInject */ ResolveClass =>
          ResolveClass.authenticateCompany('/author/:id/courses/:courseId')
      },
      views: {
        'a@app': {
          template: authorCoursesCourseTemplate,
          controller: 'AuthorCoursesCourseController'
        }
      }
    })
    .state('app.author.courses.course.edit', {
      url: '/edit',
      stateName: 'Update Course Information',
      data: {
        specialClass: 'fixed-sidebar',
        pageTitle: 'Edit Course'
      }
    })
    .state('app.author.evaluationForms', authorEvaluationFormsState)
    .state('app.author.evaluationForms.evaluationForm', authorEvaluationFormsEvaluationFormState)
    .state('app.author.evaluationForms.evaluationForm.edit', authorEvaluationFormsEvaluationFormEditState);

  if (!window.location.origin) {
    window.location.origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  }

  angularAuth0Provider.init({
    domain: 'cpesuite.auth0.com',
    clientID: 'nlc2AmadW99fi0jAZ1jHtF5ZzR1pkafD',
    connection: 'Username-Password-Authentication',
    redirectUri: `${window.location.origin}/auth0`,
    responseType: 'token'
  });
}



// WEBPACK FOOTER //
// ./src/app/routes.js